import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import './ProductDeleteModal.style.less'

interface Props {
  open: boolean
  productName: string
  loading?: boolean
  onCancel: () => void
  onDelete: () => void
}

function ProductDeleteModal(props: Props) {
  return (
    <Modal
      centered
      closable={false}
      footer={false}
      open={props.open}
      width={344}
      className="product-delete-modal"
      onCancel={props.onCancel}
    >
      <div className="product-delete-modal-content">
        <div className="product-delete-modal-title-row">
          <ExclamationCircleFilled className="product-delete-modal-icon" />
          <p className="product-delete-modal-title">
            Delete product <b>{props.productName}</b>?
          </p>
        </div>
        <p className="product-delete-modal-description">
          {"You won't be able to access it anymore."}
        </p>
        <div className="product-delete-modal-actions">
          <Button
            className="product-delete-modal-cancel-button"
            disabled={props.loading}
            size="large"
            onClick={props.onCancel}
          >
            Cancel
          </Button>
          <Button
            className="product-delete-modal-delete-button"
            loading={props.loading}
            disabled={props.loading}
            size="large"
            type="primary"
            onClick={props.onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ProductDeleteModal
